import { useEffect, useState, useRef } from "react";
import FormInput from "../../components/formInput/formInput";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../config/axios";
import { NotificationManager } from "react-notifications";
import HomepageLoader from "../../components/UI/HomepageLoader";
import Head from "next/head";
import { loader } from "../../store/actions/loader";
import InlineLoading from "../../components/UI/inlineLoader";
import Router from "next/router";
import { useRouter } from "next/router";
import { usePaystackPayment } from "react-paystack";
const GiftCardTab = () => {
  const [selected, setSelected] = useState(false);
  const [giftcardAmount, setGiftcardAmount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [showDiv, setShowDiv] = useState(1);
  const [showBalance, setShowBalance] = useState(true);
  const [walletBalance, setWalletBalance] = useState("");
  const [giftCardValue, setGiftCardValue] = useState("");
  const [giftCardAmount, setGiftCardAmount] = useState("");
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const [giftCardQuantity, setGiftCardQuantity] = useState(1);
  const [fullname, setFullname] = useState("");
  const [address, setaddress] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState({});
  let token = useSelector((state) => state.auth.token);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [inlineLoader, setInlineLoader] = useState(false);
  const [isWarningVisible, setIsWarningVisible] = useState(false);
  const loggedIn = useSelector((state) => state.auth.loggedIn);
  let user = useSelector((state) => state.auth.user) || {};
  const dispatch = useDispatch();
  const [opayDetails, setOpayDetails] = useState();
  const [opayInitLoading, setOpayInitLoading] = useState(false);
  const loadingState = useSelector((state) => state.loader.loading);
  const [timeLeft, setTimeLeft] = useState(null);
  const [opayLoading, setOpayLoading] = useState(false);
  const [opayReference, setOpayReference] = useState("");
  const [confirmOpayError, setConfirmOpayError] = useState(false);
  const [confirmPayment, setConfirmPayment] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState(null);
  const [disableCloseBtn, setDisableCloseBtn] = useState(true);
  const [transactionId, setTransactionId] = useState("");
  const [availableGateways, setAvailableGateways]  = useState([]);
  const [giftCardInput, setGiftCardInput] = useState("");
  const [recipientDetails, setRecipientDetails] = useState({
    fullname: fullname,
    address: address,
    email: email,
    phone: phone,
    message: message,
    quantity: giftCardQuantity,
    amount: giftCardValue,
    total: giftCardQuantity * giftCardValue,
  });
  const [giftCardMaxAmount, setGiftCardMaxAmount] = useState(null);
  const [giftCardMinAmount, setGiftCardMinAmount] = useState(null);
  const [warningMessage, setWarningMessage] = useState("");
  const [copiedField, setCopiedField] = useState(null);
  const [opayref, setOpayRef] = useState("");
  const router = useRouter();
 

  
  useEffect(() => {
    setRecipientDetails({
      fullname,
      address,
      email,
      phone,
      message,
      quantity: giftCardQuantity,
      amount: giftCardValue,
      total: giftCardQuantity * giftCardValue,
    });
  }, [
    fullname,
    address,
    email,
    phone,
    message,
    giftCardQuantity,
    giftCardValue,
  ]);

  const loginRedirect = () => {
    const closeBtn = document.getElementById("closePayment");
 closeBtn.click();
    const response = [recipientDetails, { previousRoute: "/giftcard" }];
    localStorage.setItem("giftcardToLogin", JSON.stringify(response));
    Router.push("/signup");
    // setTimeout(() => {

    // }, 300);
  };
const handleCopy = (text, field) => {
  navigator.clipboard.writeText(text);
  setCopiedField(field);
  setTimeout(() => setCopiedField(null), 2000);  // reset after 2 seconds
};
  const storedRecipientDetails = () => {
    setRecipientDetails({
      fullname,
      address,
      email,
      phone,
      message,
      quantity: giftCardQuantity,
      amount: giftCardValue,
      total: giftCardQuantity * giftCardValue,
    });

    localStorage.setItem("recipientDetails", JSON.stringify(recipientDetails));
   
  };

  const fetchDetails = () => {
    setTimeout(() => {
      const storedDetails = localStorage.getItem("recipientDetails");

      setRecipientDetails(JSON.parse(storedDetails));
      
    }, 5000);
  };

  useEffect(() => {
    const storedDetails = localStorage.getItem("walletCookies");
   

    if (storedDetails !== "/wallet") {
      const parsedDetails = JSON.parse(storedDetails);
      if (Array.isArray(parsedDetails) && parsedDetails.length > 0) {
        const detailsObject = parsedDetails[0];
        
        // You can now use detailsObject as needed
        setRecipientDetails(detailsObject);
        setGiftCardQuantity(detailsObject.quantity);
        setFullname(detailsObject.fullname);
        setaddress(detailsObject.address);
        setEmail(detailsObject.email);
        setPhone(detailsObject.phone);
        setMessage(detailsObject.message);
        setGiftCardValue(detailsObject.amount);
      }
    }
  }, []);

 const giftcards = [
  { amount: 5000, id: 1, url: "/images/giftcard-1.png" },
  { amount: 10000, id: 2, url: "/images/giftcard-2.png" },
  { amount: 15000, id: 3, url: "/images/giftcard-3.png" },
  { amount: 20000, id: 4, url: "/images/giftcard-4.png" },
];

  const today = new Date();

  const day = today.getDate();
  const month = today.toLocaleString("default", { month: "long" });
  const year = today.getFullYear();

  // Function to get ordinal suffix (st, nd, rd, th)
  const getOrdinalSuffix = (n) => {
    const j = n % 10,
      k = n % 100;
    if (j === 1 && k !== 11) return n + "st";
    if (j === 2 && k !== 12) return n + "nd";
    if (j === 3 && k !== 13) return n + "rd";
    return n + "th";
  };

  const formattedDate = `${getOrdinalSuffix(day)} ${month} ${year}`;

  

  const onchangeGiftcardOption = (event) => {
    setGiftcardAmount(event.target.value);
   
  };
  const handleCardChange = (index, event) => {
    setSelectedCard(index);
    onchangeGiftcardOption(event);
  };
  const handlePrevClick = () => {
    setShowDiv(1);
  };

  const handleContinueClick = () => {
    setShowDiv(2);
  };
  const handleNextClick = () => {
    const newErrors = {};

    if (!fullname) {
      newErrors.fullname = "Full name is required";
    }

    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Email address is invalid";
    }
    // else if (user?.email === recipientDetails.email) {
    //   newErrors.email = "You cannot purchase a giftcard for yourself!";
    // }

    if (!phone) {
      newErrors.phone = "Phone number is required";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      setShowDiv(3);
    }
  };

  const handleInputChange = (event, setFunction, fieldName) => {
    setFunction(event.target.value);
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[fieldName];
      return newErrors;
    });
  };
  useEffect(() => {
    if (token) {
      getWalletBalance();
    }
  }, [token]);
  const getWalletBalance = async () => {
    try {
      const {
        data: { data: wallet },
      } = await axiosInstance.get("V1/wallet/get", {
        headers: { Authorization: `Bearer ${token}` },
      });
     
      setWalletBalance(wallet.amount);

      return { wallet };
    } catch (error) {
      
      return { wallet: {} };
    }
  };
  const toggleBalance = () => {
    setShowBalance(!showBalance);
  };
  const formatNumber = (value) => {
    // Remove non-numeric characters except for decimal point if needed
    const numericValue = value.replace(/[^0-9]/g, "");
    if (!numericValue) return "";

    return Number(numericValue).toLocaleString("en-US");
  };
  const handleGiftCardInputChange = (e) => {
    const value = e.target.value;
    const formattedValue = formatNumber(value);
    setGiftCardValue(value);
    setGiftCardAmount(formattedValue);
   

    if (!value || value < 1000 || value > 50000) {
      setIsWarningVisible(true);
    } else {
      setIsWarningVisible(false);
    }
  };
  const isButtonDisabled = isWarningVisible || !giftCardValue;

  const multiplyGiftCardValue = (event) => {
    const newValue = event.target.value;
    setGiftCardQuantity(newValue);
  };

  const handleGiftCardPaymentChange = (e) => {
    setPaymentMethod(e.target.value);
   
  };
  const initializePayment = usePaystackPayment({
    reference: transactionId,
    email: user?.email,
    amount: recipientDetails.total * 100, // Convert amount to kobo
    publicKey: process.env.NEXT_PUBLIC_PAYSTACK_KEY,
  });
  const startNombaCheckout = async () => {
    const { useNombaCheckout } = await import("react-nomba-checkout-sdk");
    if (!transactionId) {
      return;
    }

    const amountToPay = parseFloat(recipientDetails.total).toFixed(2);

    await useNombaCheckout({
      accountId: process.env.NEXT_PUBLIC_ACCOUNT_ID,
      clientId: process.env.NEXT_PUBLIC_CLIENT_ID,

      order: {
        orderReference: transactionId,
        callbackUrl: `${window.location.origin}/giftcard`,
        customerEmail: user?.email,
        customerId: user?.id,
        amount: amountToPay,
        currency: "NGN",
        accountId: process.env.NEXT_PUBLIC_SUB_ID,
      },

      tokenizeCard: false,

      onCreateOrder: (ref) => {
       
      },

      onFailure: (err) => {
        
      },

      onClose: () => {
        
      },

      onPaymentSuccess: async (res) => {
       

        try {
          const payload = {
            trx_ref: res.data.order?.orderReference,
            amount: recipientDetails.total,
            payment_method: "nomba",
          };
          const { data: responseData } = await axiosInstance.post(
            "V1/giftcard/complete",
            payload,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
         
          NotificationManager.success(
            "Giftcard purchased successfully!",
            "",
            3000
          );
          localStorage.removeItem("walletCookies");

          window.location.reload();
        } catch (error) {
          
          const backendMessage =
            error?.response?.data?.message || // ✅ your API message
            error?.message || // fallback JS error
            "Something went wrong";

          NotificationManager.error(backendMessage, "", 3000);
        }
      },
    });
  };
  useEffect(() => {
    if (transactionId && paymentMethod === "flutterwave") {
      const trans = FlutterwaveCheckout({
        public_key:
          process.env.environment === "production"
            ? "FLWPUBK-5af808d4b6e113787bcebbec233254b0-X"
            : "FLWPUBK_TEST-8088fffdc0d59263e1f7a490f6fc76c8-X",
        tx_ref: transactionId,
        amount: recipientDetails.total,
        currency: "NGN",
        country: "NG",
        payment_options: "card, mobilemoneyghana, ussd",
        meta: {
          consumer_id: 23,
          consumer_mac: "92a3-912ba-1192a",
        },
        customer: {
          email: loggedIn ? user?.email : null,
          phone_number: loggedIn ? user?.phone : null,
          name: loggedIn ? user?.first_name + " " + user?.last_name : null,
        },
        callback: async (data) => {
          
          try {
            const payload = {
              trx_ref: data.tx_ref,
              amount: data.amount,
              payment_gateway: "flutterwave",
            };
            const topUpResponse = await axiosInstance.post(
              "V1/wallet/top-up/complete",
              payload,
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            );

           

            const giftCardPayload = {
              email: recipientDetails.email,
              name: recipientDetails.fullname,
              amount: recipientDetails.total,
              payment_method: "wallet",
              message:
                recipientDetails.message === ""
                  ? "use card for your groceries"
                  : recipientDetails.message,
              description: "Created Giftcard",
            };
            const giftCardResponse = await axiosInstance.post(
              "V1/giftcard",
              giftCardPayload,
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            );

         
            setInlineLoader(false);
            NotificationManager.success(
              "Gift card purchase successful",
              "",
              3000
            );
            trans.close();
            localStorage.removeItem("walletCookies");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          } catch (error) {
            console.error(error);
            NotificationManager.error(
              "An error occurred during the transaction",
              "",
              3000
            );
            trans.close();
          }
        },
        customizations: {
          title: "Killimanjaro",
          description: "Payment for wallet funding",
          logo: "/images/logo-2.png",
        },
      });
      //
    } else if (transactionId && paymentMethod === "paystack") {
      const handleGiftcardPaymentSuccess = (data) => {
  (async () => {
    try {
      const payload = {
        trx_ref: data.reference,
        //amount: recipientDetails.total,
        payment_method: "paystack",
      };

      const { data: responseData } = await axiosInstance.post(
        "V1/giftcard/complete",
        payload,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      NotificationManager.success(
        "Giftcard purchased successfully!",
        "",
        3000
      );
      localStorage.removeItem("walletCookies");

      window.location.reload();
    } catch (error) {
      NotificationManager.error(error.response?.data?.message, "", 3000);
    }
  })();
};

const handleGiftcardPaymentClose = () => {
  // no-op, kept for clarity/future use
};

initializePayment({
  onSuccess: handleGiftcardPaymentSuccess,
  onClose: handleGiftcardPaymentClose,
});
      // initializePayment({
      //   onSuccess: async (data) => {
       

      //     try {
      //       const payload = {
      //         trx_ref: data.reference,
      //         //amount: recipientDetails.total,
      //         payment_method: "paystack",
      //       };
      //       const { data: responseData } = await axiosInstance.post(
      //         "V1/giftcard/complete",
      //         payload,
      //         {
      //           headers: { Authorization: `Bearer ${token}` },
      //         }
      //       );
            
      //       NotificationManager.success(
      //         "Giftcard purchased successfully!",
      //         "",
      //         3000
      //       );
      //       localStorage.removeItem("walletCookies");

      //       window.location.reload();
      //     } catch (error) {
            
      //       NotificationManager.error(error.response?.data?.message, "", 3000);
      //     }
      //   },
      //   onClose: () => {
          
      //   },
      // });
    } else if (transactionId && paymentMethod === "nomba") {
      startNombaCheckout();
    }
  }, [transactionId]);

  const buyGiftCardHandler = async () => {
    if (!loggedIn) {
      NotificationManager.error(
        "Please Log in/Sign up to complete your purchase",
        "",
        5000
      );
    } else {
      try {
        setInlineLoader(true);
        if (paymentMethod === "paystack" || paymentMethod === "nomba") {
          const body = {
            email: recipientDetails.email,
            payment_method: paymentMethod,
            amount: recipientDetails.total,
            name: recipientDetails.fullname,
            message:
              recipientDetails.message === ""
                ? "use card for your groceries"
                : recipientDetails.message,
            platform: "web",
          };
          const res = await axiosInstance.post("V1/giftcard/initiate", body, {
            headers: { Authorization: `Bearer ${token}` },
          });
          
          const transactionNo = res.data.data.transaction.tx_ref;
         

          setTransactionId(transactionNo);
          setInlineLoader(false);
        }
        if (paymentMethod === "flutterwave") {
          setPaymentMethod("flutterwave");

        
        } else if (paymentMethod === "interswitch") {
          setPaymentMethod("interswitch");
          let transRef = `kilimanjaro-${Math.floor(
            Math.random() * 99999999999
          )}-in`;

          let amount = String(recipientDetails.total) * 100;

          // let itemId = "101";
          // let itemId = "7446983";
          let itemId = "8879118";

          // let siteRedirectUrl = "http://167.172.177.79";
          let siteRedirectUrl = "https://kilimanjaro-restaurants.com/wallet";
          //let siteRedirectUrl = "http://localhost:3001/wallet";

          // let macKey = "D3D1D05AFE42AD50818167EAC73C109168A0F108F32645C8B59E897FA930DA44F9230910DAC9E20641823799A107A02068F7BC0F4CC41D2952E249552255710F";
          let macKey =
            "SMPUGKHXyMTqlci9NWO7Pj1gLEw3mejdQYv2jh01Scey2wGu44KAb1CsV80ngHxBtT8DKTeMCDbaRaqgjhVCNgF76u6pxCFhNOVQZ0114UdcWQNisUbjaAsc5lPhQlrL";

          // let productId = '1076';
          let productId = "22143593";

          let sha512 = require("sha512");
          let hashString =
            transRef + productId + itemId + +amount + siteRedirectUrl + macKey;
          let hash = sha512(hashString).toString("hex").toUpperCase();

          const obj = {
            // postUrl: "https://sandbox.interswitchng.com/collections/w/pay",
            postUrl: "https://webpay.interswitchng.com/collections/w/pay",

            amount,
            productId,
            transRef,
            siteName: "Kilimanjaro",
            itemId,
            customerId: "84",
            siteRedirectUrl,
            currency: "NGN",
            hash,
            onComplete: async (interswitchResponse) => {
              let paymentResponse = interswitchResponse.resp;
              if (paymentResponse === "00") {
                try {
                  const payload = {
                    trx_ref: transRef,
                    amount: inputValue,
                    payment_gateway: "interswitch",
                    description: "You added money to your wallet",
                  };
                  const { response } = await axiosInstance.post(
                    "V1/wallet/top-up",
                    payload,
                    {
                      headers: { Authorization: `Bearer ${token}` },
                    }
                  );
                

                  const giftCardPayload = {
                    email: recipientDetails.email,
                    name: recipientDetails.fullname,
                    amount: recipientDetails.total,
                    payment_method: "wallet",
                    message:
                      recipientDetails.message === ""
                        ? "use card for your groceries"
                        : recipientDetails.message,
                    description: "Created Giftcard",
                  };
                  const giftCardResponse = await axiosInstance.post(
                    "V1/giftcard",
                    giftCardPayload,
                    {
                      headers: { Authorization: `Bearer ${token}` },
                    }
                  );

                  
                  setInlineLoader(false);
                  NotificationManager.success(
                    "Gift card purchase successful",
                    "",
                    3000
                  );
                  localStorage.removeItem("walletCookies");
                  
                  window.location.reload();
                
                } catch (error) {
                
                  dispatch(loader());
                  setInlineLoader(false);
                  NotificationManager.error(
                    error.response.data.message,
                    "",
                    3000
                  );
                }
              } else {
                let errorResponse = "";
                if (paymentResponse === "51") {
                  errorResponse = "Insufficient Funds";
                } else if (paymentResponse === "Z6") {
                  errorResponse = "You've cancelled payment";
                } else if (paymentResponse === "56") {
                  errorResponse = "Card record not found";
                } else if (paymentResponse === "61") {
                  errorResponse = "Card record not found";
                } else if (paymentResponse === "Z1") {
                  errorResponse = "Transaction Error";
                } else {
                  errorResponse = "Transaction Error";
                }
                // setInterswitchResponse(errorResponse);
                // updateInterswitchTransaction(
                //   transRef,
                //   errorResponse,
                //   paymentResponse
                // );

                jQuery.noConflict();
                $("#interswitchModal").modal("show");

                return;
              }
            },
          };
          new IswPay(obj);
        } else if (paymentMethod === "") {
          NotificationManager.error("Please select a payment option", "", 3000);
          setInlineLoader(false);
        } else if (paymentMethod === "opay" && confirmPayment === "PENDING") {
          NotificationManager.error("You are yet to make payment", "", 3000);
          setInlineLoader(false);
        } else if (
          paymentMethod === "wallet" &&
          walletBalance >= recipientDetails.total
        ) {
          const processWalletPayment = async () => {
            setInlineLoader(true);
            try {
              const payload = {
                email: recipientDetails.email,
                name: recipientDetails.fullname,
                amount: recipientDetails.total,
                payment_method: "wallet",
                message:
                  recipientDetails.message === ""
                    ? "use card for your groceries"
                    : recipientDetails.message,
                description: "Created Giftcard",
              };

              const response = await axiosInstance.post(
                "V1/giftcard",
                payload,
                {
                  headers: { Authorization: `Bearer ${token}` },
                }
              );

              
              setInlineLoader(false);
              NotificationManager.success(
                "Gift card purchase successful",
                "",
                3000
              );
              localStorage.removeItem("walletCookies");
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            } catch (error) {
              setInlineLoader(false);
              NotificationManager.error(
                error.response?.data?.message,
                "",
                3000
              );
            }
          };

          processWalletPayment();
        } else if (
          paymentMethod === "wallet" &&
          walletBalance < recipientDetails.total
        ) {
          NotificationManager.error("Insufficient Balance", "", 3000);
          setInlineLoader(false);
        }
      } catch (err) {
        
        setInlineLoader(false);
      }
    }
  };

  const getOpayAccount = async (data) => {
    if (loggedIn || data) {
      setOpayInitLoading(true);
      dispatch(loader());
     
      try {
        const response = await axiosInstance.post(
          "V1/giftcard/initiate",
          {
            email: recipientDetails.email,
            amount: recipientDetails.total,
            payment_method: paymentMethod,
            name: recipientDetails.fullname,
            message:
              recipientDetails.message === ""
                ? "use card for your groceries"
                : recipientDetails.message,
            platform: "web",
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      
        

        // const result = JSON.parse(response.data.result)
        const result = response.data.data.transfer_details.reference;
        
        setOpayReference(result);
        setTransactionId(response.data.data.transaction.tx_ref);

        setOpayDetails(response.data.data.transfer_details.nextAction);
        
        setPaymentAmount(
          response.data.data.transfer_details.paymentAmount.total
        );
        calculateTimeDifference(
          response.data.data.transfer_details.nextAction.expiredTimestamp
        );

        setOpayInitLoading(false);
        dispatch(loader());
      } catch (error) {
        
        setOpayInitLoading(false);
        dispatch(loader());
      }

     
    }
  };
  const handleUpdateClick = () => {
      if (typeof $ !== "undefined") {
         $("#closeUpdatePhoneNumberModalGiftcard").click();
    Router.push("/account/edit-account");

      }
   
  };
  useEffect(() => {
   
    if (user) {
      const modalButton = document.getElementById("update-modal-giftcard");
      if (user?.phone === null) {
        modalButton.click();
        return;
      }
    }
  }, [user]);

  useEffect(() => {
    if (paymentMethod === "opay") {
      getOpayAccount();
    }
  }, [recipientDetails.total, paymentMethod]);

  useEffect(() => {
    calculateTimeDifference(opayDetails?.expiredTimestamp);
    while (timeLeft !== 0) {
      //Update the time difference every 1 second
      const intervalId = setInterval(
        () => calculateTimeDifference(opayDetails?.expiredTimestamp),
        60000
      );

      // Clean up the interval when the component unmounts
      return () => clearInterval(intervalId);
    }
  }, [opayDetails]);
  const calculateTimeDifference = (timestamp) => {
    // Get the current timestamp
    const currentTimestamp = Math.floor(Date.now() / 1000); // Convert milliseconds to seconds

    // Calculate the time difference in minutes
    const timeDifferenceMinutes = Math.abs((timestamp - currentTimestamp) / 60);

  
    setTimeLeft(Math.floor(timeDifferenceMinutes));
  };
  const checkStatus = async () => {
    setOpayLoading(true);
    dispatch(loader());
   

    try {
      const response = await axiosInstance.post(
        "V1/opay/check-payment-status",
        {
          reference: transactionId,
        }
      );
     
      const status = response.data.data.status;
      setConfirmPayment(response.data.data.status);
      setOpayRef(response.data.data.orderNo);
      if (paymentMethod === "opay" && status === "SUCCESS") {
        //buyGiftCardHandler()
        const completeGiftcardPurchase = async () => {
          try {
            const payload = {
              trx_ref: transactionId,
              // amount: recipientDetails.total,
              payment_method: "opay",
            };
            const { data } = await axiosInstance.post(
              "V1/giftcard/complete",
              payload,
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            );
          
            NotificationManager.success(
              "Gift Card purchased successfully",
              "",
              3000
            );

            localStorage.removeItem("walletCookies");
            // Reload the window
            window.location.reload();
          } catch (error) {
            NotificationManager.error(error.response?.data?.message, "", 3000);
          }

          // Notification for success
        };

        // Call the function
        await completeGiftcardPurchase();
      }
      setDisableCloseBtn(false);

      
      document.getElementById("payment-stat").click();
      dispatch(loader());
      setOpayLoading(false);
    } catch (err) {
     
      setOpayLoading(false);
      dispatch(loader());
    }
  };

  //verify payment and checkout
  const verifyPayment = async () => {
  
    dispatch(loader());
    try {
      const response = await axiosInstance.post("opay/check-payment-status", {
        reference: opayReference,
      });
      
      setConfirmPayment(response.data);

      dispatch(loader());
      if (response.data.data.status === "SUCCESS") {
       
        updateOrderPayment(
          Math.floor(Math.random() * 99999999),
          response.data.data.reference
        );
      } else {
        
        setConfirmOpayError(true);
        document.getElementById("payment-status").click();
       
      }
    } catch (err) {
     
     
      dispatch(loader());
    }
  };
  useEffect(() => {
    localStorage.setItem("recipientDetails", JSON.stringify(recipientDetails));
    
  }, [recipientDetails]);
  useEffect(() => {
    const storedValue = localStorage.getItem("giftcard-max-amount");
    const storedMinValue = localStorage.getItem("giftcard-min-amount");

    if (!storedValue) return; // stops if null

    const numericValue = Number(storedValue);
    const numericMinValue = Number(storedMinValue);

    if (!Number.isNaN(numericValue)) {
      setGiftCardMaxAmount(numericValue);
      setGiftCardMinAmount(numericMinValue)
    }
  }, []);
  useEffect(() => {
    const stored = JSON.parse(
      localStorage.getItem("available-payment-gateway") || "[]"
    );
  
    setAvailableGateways(stored);
  }, []);
  const isGatewayAvailable = (gateway) => {
    return availableGateways.includes(gateway);
  };
  const redeemGiftCard = async () => {
      if (!loggedIn) {
        NotificationManager.error(
          "Please Log in/Sign up to redeem giftcard",
          "",
          5000
        );
      } else if (giftCardInput) {
        setInlineLoader(true);
        const closeBtn = document.getElementById("closeRedeemGiftCard");
        
        try {
          const payload = {
            gift_card_code: giftCardInput,
          };
          const response = await axiosInstance.post(
            "V1/giftcard/redeem",
            payload,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
  
        
          setInlineLoader(false);
          NotificationManager.success(
            "Gift card redeemed succesfully!",
            "",
            3000
          );
          closeBtn.click();
         
  
          
        }  catch (error) {
          setInlineLoader(false);
        
          // Extract specific error message if available
          const backendErrors = error.response?.data?.errors;
          const specificError = backendErrors
            ? Object.values(backendErrors).flat()[0] // gets the first message from errors object
            : error.response?.data?.message || "An unexpected error occurred.";
        
          NotificationManager.error(specificError, "", 3000);
        
          
        }
      } 
     
    };
     const loginRedirectToGiftcard = () => {
        const closeBtn = document.getElementById("closePaymentWalletFunding");
     closeBtn.click();
       
        localStorage.setItem("giftcardToLogin", "/giftcard");
        Router.push("/signup");
      };
  useEffect(() => {
    const initNomba = async () => {
      const { InitializeNombaCheckout } = await import(
        "react-nomba-checkout-sdk"
      );
  
      InitializeNombaCheckout();
    };
  
    initNomba();
  }, []);
  
  
  return (
    <>
      <Head>
        

        
      </Head>

      <section>
        <div id="first-div" className={showDiv === 1 ? "d-block" : "d-none"}>
          <div className="d-flex justify-content-center px-2 pt-3">
            <div className="stepper__header d-flex align-items-center">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="stepper__step stepper__step--active">
                  <img
                    src="/images/check-mark.svg"
                    className="stepper__image"
                  />
                </div>
                <p className="text-black pt-4 stepper__text">GiftCard</p>
              </div>

              <div className="stepper__connector"></div>

              <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="stepper__step stepper__step__inactive"></div>
                <p className="text-black pt-4 stepper__text">Recipient</p>
              </div>

              <div className="stepper__connector"></div>

              <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="stepper__step stepper__step__inactive"></div>
                <p className="text-black pt-4 stepper__text">Summary</p>
              </div>
            </div>
          </div>

          <div className="checkout-section container">
          <div className="row m-0">
            <div className="container col-md-5 col-12 redeem-giftcard-container mt-2 mb-3 py-4">
            
              
              <h6 className="text-center">Redeem Giftcard</h6>
                <p className=" text-center grey-text-1">Have a gift card to redeem? You can redeem it below.</p>
              
             
                      <div className=" justify-content-center">
                      
                      <div className="  d-flex justify-content-center">
                       
                         {
  loggedIn ? (<> <button
    className="btn select-tool  w-100 mt-3"
    data-toggle="modal"
    data-target="#giftcardModal"
    id="inactive-modal"
  >
    
    <span className="text text-center text-nowrap">
      Redeem Giftcard
    </span>
  </button></>) : (<> <button
    className="btn select-tool  w-100 mt-3"
    
    onClick={loginRedirect}
  >
   
    <span className="text text-center text-nowrap">
    Redeem Giftcard
    </span>
  </button></>)
 }
                      </div>
                        
                      </div>
          </div>
          </div>
           <div className="d-flex justify-content-center  mb-3">
                <div className="inputamount_dash "></div>
                <p className=" text-center text-danger font-weight-bold">
                  OR
                </p>{" "}
                <div className="inputamount_dash"></div>
              </div>
            <div>
              <div className="giftcard-container container">
                <h6 className=" text-center">Purchase Giftcard </h6>
                <p className="text-center grey-text-1 mb-4">Select giftcard to purchase</p>
                <>
  {/* Mobile Slider */}
  <div className="giftcard-slider-mobile d-md-none">
    {giftcards.map((item, index) => (
      <div key={index} className="giftcard-slide">
        <label
          className={`giftcard giftcard-single w-100 ${
            selectedCard === index ? "selected" : "unselected"
          }`}
        >
          <div className="d-flex flex-column justify-content-center">
            <img
              className="img-fluid mx-auto giftcard-image"
              src={item.url || "/images/gift-card-new.png"}
              alt="gift card"
            />

            <div className="px-3 mb-3">
              <p className="mt-5 py-3 text-center mx-auto giftcard-amount-btn">
                ₦{parseInt(item.amount).toLocaleString("en-US")}
              </p>
            </div>
          </div>

          <div className="d-flex mb-1">
            <input
              type="radio"
              value={item.amount}
              name="radio-mobile"
              className="radio ml-auto"
              onChange={(event) => {
                handleCardChange(index, event);
                setGiftCardValue(event.target.value);
                handleContinueClick();
              }}
              checked={selectedCard === index}
              style={{ visibility: "hidden" }}
            />
          </div>
        </label>
      </div>
    ))}
  </div>

  {/* Tablet/Desktop Grid */}
  <div className="row px-5 d-none d-md-flex">
    {giftcards.map((item, index) => (
      <div
        key={index}
        className="col-md-6 col-lg-3 d-flex justify-content-center"
      >
        <label
          className={`giftcard giftcard-single w-100 ${
            selectedCard === index ? "selected" : "unselected"
          }`}
        >
          <div className="d-flex flex-column justify-content-center">
            <img
              className="img-fluid mx-auto giftcard-image"
              src={item.url || "/images/gift-card-new.png"}
              alt="gift card"
            />

            <div className="px-3 mb-3">
              <p className="mt-5 py-3 text-center mx-auto giftcard-amount-btn">
                ₦{parseInt(item.amount).toLocaleString("en-US")}
              </p>
            </div>
          </div>

          <div className="d-flex mb-1">
            <input
              type="radio"
              value={item.amount}
              name="radio-desktop"
              className="radio ml-auto"
              onChange={(event) => {
                handleCardChange(index, event);
                setGiftCardValue(event.target.value);
                handleContinueClick();
              }}
              checked={selectedCard === index}
              style={{ visibility: "hidden" }}
            />
          </div>
        </label>
      </div>
    ))}
  </div>
</>
                {/* <div className="row px-5 giftcard-slider-mobile d-md-none">
                  {giftcards.map((item, index) => (
                    <div className="col-6 col-md-6 col-lg-3 d-flex justify-content-center giftcard-slide">
                      <label
                        key={index}
                        className={`giftcard giftcard-single w-100   ${
                          selectedCard === index ? "selected" : "unselected"
                        }`}
                      >
                        

                        <div className=" d-flex flex-column justify-content-center ">
                          <img
                            className="img-fluid mx-auto giftcard-image"
                            src={item.url || "/images/gift-card-new.png "}
                            alt="gift card"
                            //style={{ width: "100px", height: "100px" }}
                            // width={120}
                            // height={120}
                          />
                          <div className="px-3 mb-3">
                            <p className=" mt-5 py-3 text-center mx-auto giftcard-amount-btn">
                              ₦{parseInt(item.amount).toLocaleString("en-US")}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex mb-1">
                          <input
                            type="radio"
                            value={item.amount}
                            name="radio"
                            className="radio ml-auto"
                            onChange={(event) => {
                              handleCardChange(index, event);
                              setGiftCardValue(event.target.value);
                              handleContinueClick();
                            }}
                            checked={selectedCard === index}
                            key={item.amount}
                            style={{ visibility: "hidden" }}
                          />
                        </div>
                      </label>
                    </div>
                  ))}
                </div> */}
              </div>
              <h6 className=" text-center mt-5 mb-4">Enter giftcard amount instead</h6>
              
              <div className="ml-0 mb-5 px-3">
                <div className="amount-payable   ">
                
                  
                   

                  <div className=" ">
                    <div className="row justify-content-center mb-1">
                      <div className="col-12 col-md-5 col-lg-5  d-flex flex-column justify-content-center  ">
                        <FormInput
                          type="text"
                          name="amount"
                          className="giftcard-value-input px-4"
                          textboxClass="w-100"
                          placeholder="Enter amount"
                          value={giftCardAmount}
                          //onChange={handleGiftCardInputChange}
                          onChange={(e) => {
                            const raw = e.target.value.replace(/,/g, ""); // remove commas
                            if (!isNaN(raw) && raw !== "") {
                              setGiftCardValue(raw); // store clean number (e.g., "50000")
                              setGiftCardAmount(Number(raw).toLocaleString()); // display as "50,000"
                            } else if (raw === "") {
                              setGiftCardValue("");
                              setGiftCardAmount("");
                            }
                            let message = "";

                            if (!raw) {
                              message = "";
                            } else if (raw < giftCardMinAmount) {
                              message = `Lowest giftcard purchase is ₦${giftCardMinAmount.toLocaleString()}`;
                              setIsWarningVisible(true);
                            } else if (raw > giftCardMaxAmount) {
                              message = `Maximum giftcard purchase is ₦${giftCardMaxAmount.toLocaleString()}`;
                              setIsWarningVisible(true);
                            } else {
                              setIsWarningVisible(false);
                            }

                            setWarningMessage(message);
                          }}
                          ref={inputRef}
                          autocompleteRef={autocompleteRef}
                        />
                      </div>
                    </div>
                    <div className="pb-5">
                      <div className="row justify-content-center">
                        <div className=" col-12 col-md-5 col-lg-5 d-flex justify-content-center mb-2">
                          <button
                            className="btn select-tool  w-100 mt-5"
                            onClick={handleContinueClick}
                            disabled={isButtonDisabled}
                          >
                            <span className="text">Continue</span>
                          </button>
                        </div>
                      </div>
                      
                      <div className="row justify-content-center">
                        <div className="col-12 col-md-4 col-lg-4  d-flex flex-column justify-content-center  ">
                          {warningMessage && (
                            <div className="mb-3 mt-3">
                              <span>
                                <img
                                  src="/images/amber-error.svg"
                                  className="img-fluid "
                                  width={30}
                                  heigth={30}
                                />
                              </span>{" "}
                              <span className="text-danger font-weight-bold">
                                {" "}
                                &nbsp; {warningMessage}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                     
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="second-div" className={showDiv === 2 ? "d-block" : "d-none"}>
          <div className="d-flex justify-content-center px-2 pt-3">
            <div className="stepper__header position-relative">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="stepper__step stepper__step--active">
                  <img
                    src="/images/check-mark.svg"
                    className="stepper__image"
                  />
                </div>
                <p className="text-black pt-4 stepper__text">Giftcard</p>
              </div>
              <div className="stepper__connector "></div>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="stepper__step stepper__step--active">
                  <img
                    src="/images/check-mark.svg"
                    className="stepper__image"
                  />
                </div>
                <p className="text-black pt-4 stepper__text">Recipient</p>
              </div>
              <div className="stepper__connector "></div>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="stepper__step stepper__step__inactive"></div>
                <p className="text-black pt-4 stepper__text">Summary</p>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row ml-0 ml-md-0 ml-lg-5 mb-5 px-0 px-md-3 px-lg-3">
              <div className="amount-payable  col-12 col-md-5 col-lg-5 ">
                <a>
                  <img
                    src="/images/back.svg"
                    className="img-fluid "
                    width={50}
                    height={[50]}
                    onClick={handlePrevClick}
                  />
                </a>
              </div>
            </div>
          </div>

          <div className="d-flex align-items-start justify-content-center  flex-wrap pt-5 mb-5">
            <div className=" col-10 col-md-3 col-lg-3 gift-card-quantity mr-4 pb-4   mb-5 ">
              <div className="d-flex  header pt-2  py-4">
                <img src="/images/send-icon.svg" width={25} height={25} />

                <h6 className="ml-3 ">Sending Gift Card</h6>
              </div>
              <div className="card-body p-0">
                <div className="d-flex  flex-column justify-content-center">
                  <img
                    className=" img-fluid  giftcard-image  mx-auto"
                    src="/images/gift-card-new.png "
                    src= {giftCardValue === "5000" ? "/images/giftcard-1.png " : giftCardValue === "10000" ? "/images/giftcard-2.png " : giftCardValue === "15000" ? "/images/giftcard-3.png " : giftCardValue === "20000" ? "/images/giftcard-4.png " : "/images/gift-card-new.png "}
                    alt="gift card"
                    
                  />
                </div>
                <div className=" mt-3 mb-3 d-flex  px-3 justify-content-center  ">
                  <p className=" mt-3 text-center mx-auto py-3 giftcard-amount-btn">
                    ₦{parseInt(giftCardValue).toLocaleString("en-US")}
                  </p>
                </div>
              </div>
            </div>
            <div className="recipient-details col-12 col-md-4 col-lg-4  py-4 px-5 mb-5">
              <h6 className="text-center">Recipient Details</h6>
              <div className="pt-3 mb-3">
                <FormInput
                  type="text"
                  name="fullname"
                  className="gift-card-input recipient"
                  placeholder="Recipient fullname*"
                  value={recipientDetails.fullname}
                  onChange={(event) =>
                    handleInputChange(event, setFullname, "fullname")
                  }
                />
                {errors.fullname && (
                  <p className="text-danger">{errors.fullname}</p>
                )}
              </div>
              <div className="pt-3 mb-3">
                <FormInput
                  type="email"
                  name="email"
                  className="gift-card-input recipient"
                  placeholder="Recipient email address*"
                  value={recipientDetails.email}
                  onChange={(event) =>
                    handleInputChange(event, setEmail, "email")
                  }
                />
                {errors.email && <p className="text-danger">{errors.email}</p>}
              </div>
              <div className="pt-3 mb-3">
                <FormInput
                  type="tel"
                  name="phone"
                  className="gift-card-input recipient"
                  placeholder="Recipient phone number*"
                  value={recipientDetails.phone}
                  onChange={(event) =>
                    handleInputChange(event, setPhone, "phone")
                  }
                />
                {errors.phone && <p className="text-danger">{errors.phone}</p>}
              </div>
              <div className="pt-3">
                <textarea
                  className="gift-card-input recipient "
                  placeholder="Message to recipient (optional)"
                  onChange={(event) => setMessage(event.target.value)}
                  value={recipientDetails.message}
                  style={{
                    height: "100px",
                  }}
                ></textarea>
              </div>
              <div className="d-flex justify-content-center ">
                <button
                  className="btn select-tool mt-5 w-100"
                  onClick={() => {
                    handleNextClick();
                    storedRecipientDetails();
                    fetchDetails();
                  }}
                >
                  <span className="text">Continue</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div id="third-div" className={showDiv === 3 ? "d-block" : "d-none"}>
          <div className="d-flex justify-content-center px-2 pt-3">
            <div className="stepper__header position-relative">
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="stepper__step stepper__step--active">
                  <img
                    src="/images/check-mark.svg"
                    className="stepper__image"
                  />
                </div>
                <p className="text-black pt-4 stepper__text">Giftcard</p>
              </div>
              <div className="stepper__connector "></div>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="stepper__step stepper__step--active">
                  <img
                    src="/images/check-mark.svg"
                    className="stepper__image"
                  />
                </div>
                <p className="text-black pt-4 stepper__text">Recipient</p>
              </div>
              <div className="stepper__connector "></div>
              <div className="d-flex flex-column justify-content-center align-items-center">
                <div className="stepper__step stepper__step--active">
                  <img
                    src="/images/check-mark.svg"
                    className="stepper__image"
                  />
                </div>
                <p className="text-black pt-4 stepper__text">Summary</p>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row ml-0 ml-md-0 ml-lg-5 mb-5 px-0 px-md-3 ">
              <div className="amount-payable  col-12 col-md-5 col-lg-5 mt-5">
                <a>
                  <img
                    src="/images/back.svg"
                    className="img-fluid "
                    width={50}
                    height={[50]}
                    onClick={handleContinueClick}
                  />
                </a>
              </div>
            </div>
          </div>

          <h4 className="text-center mt-5">Summary</h4>
          <p className="text-center py-2  mb-4" style={{ color: "#908980" }}>
            {formattedDate}
          </p>
          <div className="container">
            <div className="row justify-content-center mb-5 mx-3">
              <div className="col-12 col-md-6 col-lg-6 border pt-2 recipient-details wallet-balance">
                <div className="row p-2">
                  <div className="col d-flex align-items-center">
                    <img
                      src="/images/wallet-icon.svg"
                      width={25}
                      height={25}
                      alt="Wallet Icon"
                    />
                    <p className="ml-3 mb-0">Wallet Balance</p>
                  </div>
                  <div className="col-auto">
                    <h5 className="mb-0">
                      &#x20A6;
                      {walletBalance && !isNaN(walletBalance)
                        ? parseInt(walletBalance).toLocaleString("en-US")
                        : "0.00"}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container ">
            <div className="row justify-content-center mx-3">
              <div className="col-12 col-md-6 col-lg-6 border py-4 px-5 recipient-details">
                <div className="row mb-2 justify-content-between">
                  <div className="col">
                    <p className="mb-0">Value(Quantity):</p>
                  </div>
                  <div className="col-auto">
                    <p className="mb-0 recipient-info">
                      ₦
                      {parseInt(recipientDetails.amount).toLocaleString(
                        "en-US"
                      )}
                      (x
                      {recipientDetails.quantity})
                    </p>
                  </div>
                </div>
                <div className="row mb-2 justify-content-between">
                  <div className="col">
                    <p className="mb-0">Delivery to:</p>
                  </div>
                  <div className="col-auto">
                    <p className="mb-0 recipient-info">
                      {recipientDetails.email}
                    </p>
                  </div>
                </div>
                <div className="row mb-2 justify-content-between">
                  <div className="col">
                    <p className="mb-0">Phone number:</p>
                  </div>
                  <div className="col-auto">
                    <p className="mb-0 recipient-info">
                      {recipientDetails.phone}
                    </p>
                  </div>
                </div>
                <div className="row mb-2 justify-content-between">
                  <div className="col">
                    <p className="mb-0">Full name:</p>
                  </div>
                  <div className="col-auto">
                    <p className="mb-0 recipient-info">
                      {recipientDetails.fullname}
                    </p>
                  </div>
                </div>
                <div className="row mb-2 justify-content-between">
                  <div className="col">
                    <p className="mb-0">Order amount:</p>
                  </div>
                  <div className="col-auto">
                    <p className="mb-0 recipient-info">
                      ₦
                      {parseInt(recipientDetails.amount).toLocaleString(
                        "en-US"
                      )}
                    </p>
                  </div>
                </div>
                <div className="row justify-content-between">
                  <div className="col">
                    <p className="mb-0">Total amount:</p>
                  </div>
                  <div className="col-auto">
                    <p className="mb-0 recipient-info">
                      ₦
                      {parseInt(recipientDetails.total).toLocaleString("en-US")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center mb-5">
            <div className="col-6 col-md-6 col-lg-6">
              <button
                className="btn select-tool mt-5 w-50 mx-auto mb-5"
                data-toggle="modal"
                data-target="#paymentModal"
                id="inactive-modal"
              >
                <span className="text">Pay</span>
              </button>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="paymentModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="paymentModalLabel"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div
            className="modal-dialog modal-dialog-centered rounded"
            role="document"
          >
            <div className="modal-content modal-body p-0">
              <div className="d-flex align-items-center background-primary modal-header">
                <h6 className="mx-auto modal-header-text text-white  ">
                  PAYMENT METHOD
                </h6>

                <a
                  data-dismiss="modal"
                  aria-label="Close"
                  id="closePayment"
                  className="px-4"
                >
                  <img src="/images/x.svg" width={30} height={30} />
                </a>
              </div>

              <div className="modal-body border-bottom ">
                <div className="px-5 payment-modal">
                  <h6 className="py-3">CHOOSE A PAYMENT METHOD</h6>
                  <div className="checkout-section">
                    <div className=" coupon-delivery-sect">
                    {
                      isGatewayAvailable("wallet") && (
                        <label className="payment d-flex align-items-center px-3 py-2 payment-method-checkbox">
                        <div className="d-flex align-items-center gap-2 flex-grow-1">
                          <img
                            className="pr-2 img-fluid"
                            src="/images/gift-card-icon.svg"
                            alt="wallet"
                            width={25}
                            height={25}
                          />

                          <p className="ml-2">Wallet</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-end payment-check-box">
                          <input
                            type="radio"
                            value="wallet"
                            name="paymentMethod"
                            onChange={handleGiftCardPaymentChange}
                            className="check radio mt-1"
                          />
                        </div>
                      </label>
                      )
                    }
                      
                      {
                        isGatewayAvailable("paystack") && (
                          <label className="payment d-flex align-items-center px-3 py-2 payment-method-checkbox">
                        <div className="d-flex align-items-center gap-2 flex-grow-1 ">
                          <img
                            className="pr-2 img-fluid "
                            src="/images/paystack-icon.svg"
                            alt="paystack"
                            width={25}
                            height={25}
                          />

                          <p className=" ml-2">Paystack</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-end payment-check-box">
                          <input
                            type="radio"
                            value="paystack"
                            name="paymentMethod"
                            className="check radio mt-1"
                            onChange={handleGiftCardPaymentChange}
                          />
                        </div>
                      </label>
                        )
                      }
                      {
                        isGatewayAvailable("nomba") && (
                          <label className="payment d-flex align-items-center px-3 py-2 payment-method-checkbox">
                        <div className="d-flex align-items-center gap-2 flex-grow-1 ">
                          <img
                            className="pr-2 img-fluid "
                            src="/images/nomba.jpeg"
                            alt="nomba"
                            width={25}
                            height={25}
                          />

                          <p className=" ml-2">Nomba</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-end payment-check-box">
                          <input
                            type="radio"
                            value="nomba"
                            name="paymentMethod"
                            className="check radio mt-1"
                            onChange={handleGiftCardPaymentChange}
                          />
                        </div>
                      </label>
                        )
                      }
                     
                     {
                      isGatewayAvailable("opay") &&  (
                        <label className="payment d-flex align-items-center px-3 py-2 payment-method-checkbox ">
                        <div className="d-flex align-items-center gap-2 flex-grow-1">
                          <img
                            className="pr-2 img-fluid"
                            src="/images/bank.svg"
                            alt="bank transfer"
                            width={25}
                            height={25}
                          />

                          <p className="ml-2">Bank Transfer</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-end payment-check-box">
                          <input
                            type="radio"
                            value="opay"
                            name="paymentMethod"
                            onChange={handleGiftCardPaymentChange}
                            // checked={paymentMethod === 'wallet'}
                            className="check radio mt-1"
                          />
                        </div>
                      </label>
                      )
                     }

                     
                      {!loggedIn && (
                        <p>
                          Please
                          <a onClick={loginRedirect} className="text-danger">
                            {" "}
                            login/signup&nbsp;
                          </a>
                          in order to purchase giftcard!
                        </p>
                      )}
                      <section>
                        {paymentMethod === "opay" && (
                          <>
                            <div className="opay">
                             {/* Pay to */}
<div className="d-flex pt-4 align-items-center">
  <h6 className="font-weight-light">Pay to:</h6>&nbsp;&nbsp;
  <h6>{opayDetails?.transferAccountNumber}</h6>&nbsp;&nbsp;
  {copiedField === "account" ? (
    <small className="text-success font-weight-bold" style={{ fontSize: "12px" }}>
      Copied!
    </small>
  ) : (
    <img
      src="/images/copy.svg"
      alt="copy"
      width={18}
      height={18}
      style={{ cursor: "pointer" }}
      onClick={() => handleCopy(opayDetails?.transferAccountNumber, "account")}
    />
  )}
</div>

{/* Amount */}
<div className="d-flex align-items-center">
  <h6 className="font-weight-light">Amount:</h6>&nbsp;&nbsp;
  <h6>
    ₦{(paymentAmount / 100).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}
  </h6>&nbsp;&nbsp;
  {copiedField === "amount" ? (
    <small className="text-success font-weight-bold" style={{ fontSize: "12px" }}>
      Copied!
    </small>
  ) : (
    <img
      src="/images/copy.svg"
      alt="copy"
      width={18}
      height={18}
      style={{ cursor: "pointer" }}
      onClick={() => handleCopy(
    String(paymentAmount / 100),   
    "amount"
  )}
    />
  )}
</div>
                              <div className="d-flex mb-2">
                                <h6 className="font-weight-light">Bank:</h6>
                                &nbsp;&nbsp;
                                <h6>{opayDetails?.transferBankName}</h6>
                              </div>
                              <p className="text-center font-weight-bold text-danger">
                                Pay exact amount. Extra charges are from the
                                gateway!
                              </p>

                              <p>
                                This account expires in{" "}
                                <span className="text-danger">
                                  {timeLeft ? timeLeft : 0}
                                </span>{" "}
                                <span className="text-danger">minutes</span> and
                                can only be used for this transaction
                              </p>
                              {loadingState && opayLoading ? (
                                <div className="d-flex justify-content-center">
                                  <InlineLoading />
                                </div>
                              ) : (
                                <button
                                  className="btn mt-3 mx-auto mb-5"
                                  onClick={() => {
                                    checkStatus();
                                  }}
                                >
                                  <span className="text">
                                    I've made payment
                                  </span>
                                </button>
                              )}
                            </div>
                          </>
                        )}
                      </section>
                      {paymentMethod !== "opay" && (
                        <button
                          style={{
                            display: "block",
                            margin: "0 auto",

                            marginBottom: "20px",
                            width: "50%",
                          }}
                          className="btn select-tool mt-5 "
                          onClick={buyGiftCardHandler}
                          disabled={!paymentMethod ||!loggedIn }
                        >
                          <span className="text">Continue</span>
                        </button>
                      )}

                      {paymentMethod === "opay" && (
                        <a
                          className="d-block text-center  red-text mb-3"
                          data-dismiss="modal"
                          aria-label="Close"
                          id="closePayment"
                        >
                          Cancel transaction
                        </a>
                      )}

                      {inlineLoader ? (
                        <div className="inline-loading-css d-flex justify-content-center">
                          <HomepageLoader />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="btn btn-primary "
          data-toggle="modal"
          data-target="#updateModalGiftcard"
          id="update-modal-giftcard"
          style={{ display: "none" }}
        >
          Launch update modal
        </button>
        <div
          className={`modal fade ${showModal ? "show" : ""}`}
          id="updateModalGiftcard"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="updateModalGiftcardLabel"
          data-backdrop="static"
          aria-hidden={!showModal}
          data-keyboard="false"
          style={{ display: showModal ? "block" : "none" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content p-4">
              <span
                data-dismiss="modal"
                aria-label="Close"
                id="closeUpdatePhoneNumberModalGiftcard"
                style={{
                  marginLeft: "auto",
                  fontSize: "15px",
                  color: "white",
                  cursor: "pointer",
                  display: "none",
                }}
                className="px-4"
              >
                <img src="/images/x.svg" width={30} height={30} />
              </span>

              <div className="modal-body">
                <p className=" text-center">
                  Please update your phone number in order to continue.
                </p>

                <button
                  style={{
                    display: "block",
                    margin: "0 auto",
                    marginBottom: "20px",
                    marginTop: "30px",
                    width: "50%",
                  }}
                  className="btn select-tool "
                  onClick={() => {
                    handleUpdateClick();
                  }}
                >
                  <span className="text">Update</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <button
          type="button"
          className="btn btn-primary "
          data-toggle="modal"
          data-target="#statModal"
          id="payment-stat"
          style={{ display: "none" }}
        >
          Launch demo modal
        </button>

        <div
          className="modal fade"
          id="statModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="StatModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content p-4">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                id="close-modal"
                aria-label="Close"
                style={{ marginLeft: "auto" }}
              >
                <span
                  aria-hidden="true"
                  className="ms-auto"
                  style={{ fontSize: "24px" }}
                >
                  &times;
                </span>
              </button>

              <div className="modal-body ">
                {loadingState && opayLoading ? (
                  <div className="d-flex justify-content-center">
                    <InlineLoading />
                  </div>
                ) : (
                  <>
                    <p
                      className=" text-center"
                      style={{ fontSize: "24px", fontWeight: "bold" }}
                    >
                      PAYMENT STATUS:{" "}
                      <span
                        style={{
                          color: confirmPayment === "PENDING" ? "red" : "green",
                        }}
                      >
                        {confirmPayment}
                      </span>{" "}
                    </p>

                    {confirmPayment !== "SUCCESS" ? (
                      <p className=" text-center">
                        We are yet to confirm your payment, please click the
                        "I've Made Payment" button again after 15 seconds.
                      </p>
                    ) : (
                      <p className=" text-center">
                        Payment confirmed!, please click the continue button.
                      </p>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade "
          id="giftcardModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="giftcardModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered rounded"
            role="document"
          >
            <div className="modal-content all-modal-content px-5 py-4" >
              <div className="d-flex align-items-center ">
                <a
                  data-dismiss="modal"
                  aria-label="Close"
                  id="closeRedeemGiftCard"
                 
                  className="px-4 ml-auto"
                >
                  <img  src="/images/x-icon-grey.png"
                    width={15}
                    height={15}
                      alt="close icon"
                    />
                   
                </a>
              </div>
              <div
                className="modal-body  "
               
              >
                <div className="px-5 payment-modal gift-card">
                  <div className="d-flex justify-content-center">
                    <img
                      src="/images/gift-card.png"
                      
                    />
                  </div>

                  <h6 className=" text-center pt-3">
                    You just received a Gift Card{" "}
                  </h6>

                  <p
                    className=" text-center pt-3"
                    
                  >
                    Type in the code sent to your email{" "}
                  </p>
                  <p
                    className=" text-center mb-2"
                    
                  >
                    {" "}
                    to redeem Gift Card.
                  </p>

                  <div className="d-flex justify-content-center col-12">
                    <FormInput
                      type="text"
                      name="amount"
                      className="gift-card-input"
                      placeholder="Enter code here"
                      ref={inputRef}
                      autocompleteRef={autocompleteRef}
                      value={giftCardInput}
                      onChange={(e) => setGiftCardInput(e.target.value)}
                      style={{
                        width: "100%",
                        height: "52px",

                        border: "1px solid #828282",
                        fontSize: "16px",
                      }}
                    />
                  </div>
                  {!loggedIn && (
                    <p className="pt-1">
                      Please
                      <a
                        onClick={loginRedirectToGiftcard}
                        className="text-danger"
                      >
                        {" "}
                        login/signup&nbsp;
                      </a>
                      in order to redeem giftcard!
                    </p>
                  )}

                  <div className="checkout-section">
                    <div className=" coupon-delivery-sect">
                      <button
                        style={{
                          display: "block",
                          margin: "0 auto",

                          marginBottom: "20px",
                          width: "50%",
                        }}
                        className="btn select-tool mt-5 "
                        disabled={!giftCardInput}
                        onClick={redeemGiftCard}
                      >
                        <span className="text">Continue</span>
                      </button>
                     
                      {inlineLoader ? (
                        <div className="inline-loading-css d-flex justify-content-center">
                          <HomepageLoader />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GiftCardTab;
